// components/About.jsx
import React from 'react';
import '../styles/About.css';
import aboutImage from '../assets/water1.png';

const About = () => {
  const features = [
    {
      icon: '🏅',
      title: 'Certified & Insured',
      description: 'Fully certified and insured restoration professionals.'
    },
    {
      icon: '⭐',
      title: '5-Star Service',
      description: 'Consistently rated 5 stars by satisfied customers.'
    },
    {
      icon: '🔧',
      title: 'Expert Technicians',
      description: 'Highly trained IICRC certified restoration experts.'
    },
    {
      icon: '💰',
      title: 'Insurance Claims',
      description: 'We work directly with your insurance company.'
    },
    {
      icon: '⚡',
      title: '24/7 Emergency',
      description: 'Round-the-clock emergency response team.'
    },
    {
      icon: '🛡️',
      title: 'Satisfaction Guarantee',
      description: '100% satisfaction guaranteed on all services.'
    }
  ];

  const whyChooseUs = [
    {
      icon: '✅',
      title: 'Licensed & Insured',
      description: 'Fully licensed and insured for your protection.'
    },
    {
      icon: '⭐',
      title: 'IICRC Certified',
      description: 'Institute of Inspection, Cleaning and Restoration Certification.'
    },
    {
      icon: '💰',
      title: 'Insurance Claim Assistance',
      description: 'We help you navigate the insurance claim process.'
    },
    {
      icon: '⚡',
      title: '60-Minute Response',
      description: 'Rapid response to minimize water damage.'
    },
    {
      icon: '🛡️',
      title: '100% Guarantee',
      description: 'We stand behind our work with a satisfaction guarantee.'
    },
    {
      icon: '🔧',
      title: 'Advanced Equipment',
      description: 'Industrial-grade equipment for professional drying.'
    },
    {
      icon: '👨‍🔧',
      title: 'Background Checked',
      description: 'All technicians are background checked and drug tested.'
    },
    {
      icon: '📞',
      title: '24/7 Support',
      description: 'Around-the-clock customer support for emergencies.'
    }
  ];

  return (
    <section id="about" className="about">
      <div className="about-bg">
        <div className="about-bg-circle about-bg-circle-1"></div>
        <div className="about-bg-circle about-bg-circle-2"></div>
        <div className="about-bg-circle about-bg-circle-3"></div>
      </div>

      <div className="about-container">
        <div className="about-grid">
          <div className="about-content">
            <span className="about-subtitle">About Us</span>
            <h2 className="about-title">
              Your Trusted <span className="about-title-highlight">Restoration Experts</span>
            </h2>
            <p className="about-description">
              At <strong>WaterDamagePro</strong>, we specialize in water damage restoration and 
              property recovery. With years of experience serving homeowners and businesses across 
              the USA, we've built a reputation for reliability and excellence.
            </p>
            <p className="about-description">
              Our team of IICRC certified technicians uses the latest equipment and techniques to 
              restore your property quickly and efficiently. From emergency water extraction to 
              complete restoration, we handle it all with precision and care.
            </p>

            <div className="about-features">
              {features.map((feature, index) => (
                <div 
                  key={index} 
                  className="about-feature"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <span className="about-feature-icon">{feature.icon}</span>
                  <div className="about-feature-content">
                    <h4 className="about-feature-title">{feature.title}</h4>
                    <p className="about-feature-description">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="about-buttons">
              <button className="about-btn-primary" onClick={() => {
                window.location.href = 'tel:+18334936236';
              }}>
                <span className="about-btn-shine"></span>
                Get a Free Quote
              </button>
              <a href="tel:+18334936236" className="about-btn-secondary">
                📞 +1 (833) 493-6236
              </a>
            </div>
          </div>

          <div className="about-image-wrapper">
            <div className="about-image-glow"></div>
            <div className="about-image-container">
              <img 
                src={aboutImage} 
                alt="Water Damage Restoration Professional" 
                className="about-image"
              />
              <div className="about-stat-card about-stat-card-1">
                <span className="about-stat-number">1000+</span>
                <span className="about-stat-label">Properties Restored</span>
              </div>
              <div className="about-stat-card about-stat-card-2">
                <span className="about-stat-number">4.9★</span>
                <span className="about-stat-label">Average Rating</span>
              </div>
              <div className="about-stat-card about-stat-card-3">
                <span className="about-stat-number">10+</span>
                <span className="about-stat-label">Years Experience</span>
              </div>
            </div>
          </div>
        </div>

        <div className="why-choose-us">
          <div className="why-choose-us-header">
            <span className="why-choose-us-subtitle">Why Choose Us</span>
            <h2 className="why-choose-us-title">
              Why <span className="why-choose-us-highlight">WaterDamagePro</span>?
            </h2>
            <p className="why-choose-us-description">
              Here's why thousands of customers trust us with their water damage restoration needs.
            </p>
          </div>

          <div className="why-choose-us-grid">
            {whyChooseUs.map((item, index) => (
              <div 
                key={index} 
                className="why-choose-us-card"
                style={{ animationDelay: `${index * 0.08}s` }}
              >
                <div className="why-choose-us-card-icon">{item.icon}</div>
                <h4 className="why-choose-us-card-title">{item.title}</h4>
                <p className="why-choose-us-card-description">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;